import React from "react";
import svgUrl from "/opt/actions-runner/_work/v3-swap/v3-swap/src/assets/svg/blank_token.svg?url";
const SvgBlankToken = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ...props
}, /* @__PURE__ */ React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  strokeWidth: 3,
  fill: "#98A1C0"
}));
export {SvgBlankToken as ReactComponent};
export default svgUrl;
